import styled from 'styled-components'
import { colors } from '~/assets/styles'

export const WheelContainer = styled.div`
  border-radius: 50%;
  border: 5px solid white;
  height: 100%;
  width: 100%;
  box-shadow: 0 28px 20px 0px rgba(0, 0, 0, 0.4);
`

export type MainRingPropsType = { color?: string }

export const MainRing = styled.div<MainRingPropsType>`
  align-items: center;
  background: ${({ color = '#000000' }) => color};
  border-radius: 50%;
  box-shadow:
    inset 0 0 15px rgba(255, 255, 255, 0.15),
    inset 0 -10px 15px rgba(0, 0, 0, 0.25);
  display: flex;
  inset: 5px;
  justify-content: center;
  position: absolute;

  button {
    background: linear-gradient(0deg, #1f7a2e -55.36%, #33cc4c 49.79%);
    border-radius: 100px;
    border: 4px solid ${colors.white};
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    color: ${colors.white};
    height: 56px;
    position: absolute;
    top: 92.8%;
    transition: all 300ms ease-in-out;
    width: 280px;
    z-index: 1000;

    &:hover {
      background: linear-gradient(0deg, #1f7a2e -55.36%, #34b53b 49.79%);
    }

    &:disabled {
      opacity: 0;
      transform: scale(0.1);
    }
  }

  .wheel-content > div {
    height: 90%;
    position: absolute;
    width: 90%;

    &::after {
      background-color: white;
      border-radius: 50%;
      box-shadow: 2px 4px 20px -5px black;
      content: '';
      height: 8%;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 8%;
      z-index: 5;
    }
  }
`

export const WheelContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  .arrow {
    pointer-events: none;
    position: absolute;
    right: 13.6%;
    top: 1.35%;
    transform: translateX(50%);
    width: 24.5%;
    z-index: 100;
  }
`

export const CenterCircle = styled.div`
  align-items: center;
  background: transparent;
  border-radius: 50%;
  box-shadow: inset 0 0 70px rgba(0, 0, 0, 0.5);
  display: flex;
  height: 84.5%;
  justify-content: center;
  position: absolute;
  width: 84.5%;
  z-index: 10;
`
